import React from "react";
import { FormProvider } from "react-hook-form";
import { Paper } from "@mui/material";

import { AgreementAppForm } from "@modules/agreementApps/components";
import { useAgreementAppCreateForm } from "./controller";

export const CreateAgreementApp = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending } = useAgreementAppCreateForm();

  return (
    <Paper style={{ padding: "16px" }}>
      <FormProvider {...methods}>
        <AgreementAppForm
          onSubmit={handleSubmit((data: any) => mutateAsync(data))}
          isSubmitting={isPending}
        />
      </FormProvider>
    </Paper>
  );
});
